import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import {
  ALERT_TABLE_COLUMNS,
  ALERT_MANAGER_SEVERITY_TO_STANDARD_ALERT_SEVERITY,
  ALERT_STATE_API_TO_UI,
  ALERT_STATE_UI_TO_API,
  STANDARD_ALERT_SEVERITY_TO_ALERT_MANAGER_SEVERITY
} from '@kentik/ui-shared/alerting/constants';
import storeLoader from 'app/stores/storeLoader';
import AlertingTable from 'app/views/alerting/components/AlertingTable';
import AlertCollection from 'app/stores/alerting/AlertCollection';
import { LinkButton } from 'core/components';
import ToolResultCard from '../components/ToolResultCard';

@storeLoader('$alerting.policyCollection')
@withRouter
@observer
class AlertToolResult extends React.Component {
  state = {
    collection: new AlertCollection()
  };

  componentDidMount() {
    const { collection } = this.state;
    const { tool } = this.props;
    // Override because we don't need server filters and it breaks inline filters.
    collection.serverSortableFields = [];
    // Override because we don't want to clearFilters on result collapse/expand.
    collection.clearFilters = () => {};

    // flatten these because the collection re-nests under filter before fetching.
    const { filter, pagination } = tool.query_object;
    collection.setServerFilter(
      { ...filter, lookback: 0 },
      {},
      {
        data: {
          offset: pagination.offset ?? 0,
          limit: pagination.limit || 1000,
          pagination: { includeTotalCount: pagination.includeTotalCount ?? false }
        }
      }
    );
  }

  getAlertingSidebarFilters = () => {
    const { tool } = this.props;
    const { filter } = tool.query_object;
    const { states, severities } = filter || {};

    if (filter?.active?.start) {
      filter.startDate = filter.active.start;
    }

    if (filter?.active?.end) {
      filter.endDate = filter.active.end;
    }

    if (Array.isArray(states) && states.length > 0) {
      filter.states = states
        .map((state) => ALERT_STATE_API_TO_UI[state] || state)
        .filter((state) => !!ALERT_STATE_UI_TO_API[state]);
    }

    if (Array.isArray(severities) && severities.length > 0) {
      filter.severities = severities
        .map((severity) => ALERT_MANAGER_SEVERITY_TO_STANDARD_ALERT_SEVERITY[severity] || severity)
        .filter((severity) => !!STANDARD_ALERT_SEVERITY_TO_ALERT_MANAGER_SEVERITY[severity]);
    }

    return { ...filter, keys: undefined, active: undefined };
  };

  handleNavigateToAlerts = () => {
    const { history } = this.props;
    const filters = this.getAlertingSidebarFilters();
    history.push('/v4/alerting', { filters });
  };

  render() {
    const { tool = {}, onCloseToolResult, isInlineMode } = this.props;
    const { collection } = this.state;

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-alerts"
        title={tool.title}
        minHeight={750}
        headerActions={
          <LinkButton icon="shield" small minimal onClick={this.handleNavigateToAlerts}>
            View in Alerting
          </LinkButton>
        }
      >
        <AlertingTable
          collection={collection}
          miniKebab
          useVirtualizedTable
          hideColumns={[ALERT_TABLE_COLUMNS.SILENCE_MODEL, ALERT_TABLE_COLUMNS.ACK_STATE_LABEL]}
        />
      </ToolResultCard>
    );
  }
}

export default AlertToolResult;
